<script setup>

import {computed} from "vue";

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: value => [
      'progress',
      'complete',
      'opportunities',
      'remove',
      'manual',
    ].includes(value),
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const buttonClassMap = {
  progress: 'tw-bg-blue hover:tw-bg-blue-dark',
  complete: 'tw-bg-everest-bright hover:tw-bg-everest-dark',
  opportunities: 'tw-bg-blue hover:tw-bg-blue-dark',
  remove: 'tw-bg-pink hover:tw-bg-pink-dark',
  manual: 'tw-bg-everest-bright hover:tw-bg-everest-dark'
}

const buttonIconMap = {
  progress: 'retry',
  complete: 'check-circle-thin',
  opportunities: 'stars',
  remove: 'trash-thin',
  manual: 'manually-complete',
}

const buttonClass = computed(() => buttonClassMap[props.variant]);
const buttonIcon = computed(() => buttonIconMap[props.variant]);
</script>

<template>
  <button
    :class="[
      'tw-rounded-lg tw-w-[52px] tw-h-[52px] tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-lg tw-text-white',
      'disabled:tw-cursor-not-allowed disabled:tw-text-slate-300 hover:tw-cursor-pointer tw-transition-colors',
      buttonClass,
    ]"
  >
    <svg-vue
      v-if="loading"
      icon="icons/loading"
      class="tw-w-6 tw-h-6 tw-text-white"
    />
    <svg-vue
      v-else
      :icon="`icons/${buttonIcon}`"
      class="tw-w-6 tw-h-6"
    />
  </button>
</template>
